<template>
    <div class="page__wrapper">
        <profileIcon :settings="profileIconSettings" v-if="showMainContent"></profileIcon>
        <logInModal :settings="logInModalSettings"></logInModal>
        <div class="main_content" v-if="showMainContent">
            <div class="logo__wrapper">
                <img src="@/assets/icons/AV_logo.svg">
            </div>
            <span>Thanks for signing in</span>
        </div>
    </div>
</template>

<script>
import logInModal from "../widgets/logInModal";
import profileIcon from "../voteFlow/widgets/profileIcon.vue";
import {mapGetters, mapState} from "vuex";

export default {
    name: "SignUpScreen",
    components: {
        logInModal, profileIcon
    },
    data() {
        return {
            profileIconSettings: {
                logoutHandler: this.doAfterLogout,
            },
            logInModalSettings: {
                show: true,
                showLogo: true,
                onGotUserCreds: this.onGotUserCreds,
                hideOnClickOutside: false,
            },
            questionUid: null,
            voteUid: null,
            showMainContent: false,
        }
    },
    computed: {
        ...mapState({
            userInfo: state => state.auth.userInfo,
            accessToken: state => state.auth.accessToken,
        }),
        ...mapGetters({
            questionManageData: 'auth/getQuestionManageData',
            isAuthorized: 'auth/isAuthorized',
        }),
        hasQuestionAccess() {
            return this.questionManageData != null && this.questionManageData.uid == this.questionUid && this.questionManageData.access
        },
    },
    mounted() {
        if(this.$route.query.qUid) {
            this.questionUid = this.$route.query.qUid
            this.$store.commit('auth/setQuestionUid', this.questionUid)
        }
        if(this.$route.query.rateUid) this.rateUid = this.$route.query.rateUid
        if(this.$route.query.rateValue) this.rateValue = this.$route.query.rateValue
        if(this.isAuthorized) this.setSignedInMode()
    },
    methods: {

        doAfterLogout() {
            this.setSignInMode()
        },

        onGotUserCreds() {
            if(this.hasQuestionAccess) {
                let url = `${location.origin}/questions/${this.questionUid}/manage`
                if(this.rateUid) url += `?rate_uid=${this.rateUid}&rate_value=${this.rateValue}`
                window.location.replace(url)
            } else {
                if(this.questionUid && this.rateUid && this.rateValue) {
                    let url = `${location.origin}/r/thank-for-vote/${this.questionUid}/${this.rateValue}/${this.rateUid}`
                    window.location.replace(url)
                } else {
                    this.setSignedInMode()
                }
            }
        },

        setSignedInMode() {
            this.logInModalSettings.show = false
            this.showMainContent = true
        },
        setSignInMode() {
            this.showMainContent = false
            this.logInModalSettings = {
                show: true,
                showLogo: true,
                onGotUserCreds: this.onGotUserCreds,
                hideOnClickOutside: true,
            }
        }

    },
}
</script>

<style scoped>
    .page__wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
    }
    .logo__wrapper {
        margin-top: 48px;
    }
    .main_content {
        display: flex;
        align-items: center;
        flex-direction: column;
    }
    .main_content span {
        margin-top: 24px;
        font-size: 18px;
    }
</style>